import type { State } from '../../reducer.tsx';

export const getError = (state: State) => state.ui.error;
